import React, { useEffect, createElement } from 'react';
export function UlfahAdvertorial() {
  // Get current date in Arabic format
  const getCurrentDateArabic = () => {
    const months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
    const date = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  // Handle CTA click
  const handleCTAClick = () => {
    window.open('https://bioseena.com/products/ulfah', '_blank');
  };
  // Tracking Scripts
  useEffect(() => {
    // Set page title
    document.title = 'اكتشاف مغربي خطير يكشف السبب الحقيقي وراء فقدان الرغبة عند الرجال... (والأطباء ساكتين)';
    // TikTok Pixel Script
    const tiktokScript = document.createElement('script');
    tiktokScript.innerHTML = `
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
        var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
        ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
        ttq.load('D4Q2B4JC77UBPV37E0SG');
        ttq.page();
      }(window, document, 'ttq');
    `;
    document.head.appendChild(tiktokScript);
    // Microsoft Clarity Script
    const clarityScript = document.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "uhgg2ruv8g");
    `;
    document.head.appendChild(clarityScript);
    // Cleanup function
    return () => {
      document.head.removeChild(tiktokScript);
      document.head.removeChild(clarityScript);
    };
  }, []);
  return <div dir="rtl" className="w-full min-h-screen bg-[#faf8f5]" data-id="element-2">
      {/* Header */}
      <header className="bg-[#2d2d2d] text-white py-4" data-id="element-3">
        <div className="max-w-4xl mx-auto px-4 flex items-center justify-between" data-id="element-4">
          <div className="text-[10px] text-gray-400" data-id="element-5">Advertorial</div>
          <div className="flex items-center gap-2" data-id="element-6">
            <span className="text-sm font-medium" data-id="element-7">🇲🇦 رائج فالمغرب</span>
          </div>
        </div>
      </header>

      {/* UPDATE Banner */}
      <div className="bg-gradient-to-l from-[#fff4d6] to-[#fef3c7] border-b-2 border-[#f59e0b]" data-id="element-8">
        <div className="max-w-4xl mx-auto px-4 py-5" data-id="element-9">
          <div className="flex items-start gap-3" data-id="element-10">
            <div className="flex-shrink-0" data-id="element-11">
              <div className="bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm" data-id="element-12">
                !
              </div>
            </div>
            <div className="flex-1" data-id="element-13">
              <p className="text-gray-900 text-base md:text-lg leading-relaxed" data-id="element-14">
                <span className="font-bold text-red-600" data-id="element-15">
                  تحديث {getCurrentDateArabic()}:
                </span>{' '}
                المخزون كيسالي بسرعة! أمّن طلبك دابا قبل ما تفوتك الفرصة.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-[#faf8f5] py-4" data-id="element-16">
        <div className="max-w-4xl mx-auto px-4" data-id="element-17">
          <nav className="text-sm text-gray-500" data-id="element-18">
            <span className="hover:text-gray-700 cursor-pointer" data-id="element-19">الرئيسية</span>
            <span className="mx-2" data-id="element-20">›</span>
            <span className="hover:text-gray-700 cursor-pointer" data-id="element-21">الصحة</span>
            <span className="mx-2" data-id="element-22">›</span>
            <span className="text-gray-700 font-medium" data-id="element-23">الصحة الزوجية</span>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <article className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-24">
        {/* Main Headline */}
        <h1 className="font-['Tajawal'] text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-8" data-id="element-25">
          <span className="text-red-600" data-id="element-26">اكتشاف مغربي صادم:</span> السبب الحقيقي
          وراء فقدان الرغبة عند الرجال...{' '}
          <span className="text-gray-500" data-id="element-27">(والأطباء ساكتين)</span>
        </h1>

        {/* Body Copy */}
        <div className="prose prose-lg max-w-none mb-12" data-id="element-28">
          <p className="text-gray-900 text-xl md:text-2xl font-bold leading-relaxed mb-6" data-id="element-29">
            واش كتخاف من الليلة الحميمية؟
          </p>

          <p className="text-gray-900 text-xl md:text-2xl font-bold leading-relaxed mb-6" data-id="element-30">
            واش كتحس براسك ما بقيتيش راجل بحال زمان؟
          </p>

          <p className="text-gray-900 text-xl md:text-2xl font-bold leading-relaxed mb-8" data-id="element-31">
            واش كتجنب مراتك باش ما تلاحظش الضعف؟
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-6 font-semibold" data-id="element-32">
            أنت ماشي وحدك.
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-4" data-id="element-33">
            7 من 10 رجال مغاربة كيعيشو نفس المعاناة... فالصمت.
          </p>

          {/* Visual 7/10 Illustration */}
          <div className="flex items-center justify-center gap-2 my-6" data-id="element-34">
            <div className="flex gap-1" data-id="element-35">
              {[...Array(7)].map((_, i) => <div key={i} className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center" data-id="element-36">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-37">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" data-id="element-38" />
                  </svg>
                </div>)}
              {[...Array(3)].map((_, i) => <div key={i} className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center" data-id="element-39">
                  <svg className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-40">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" data-id="element-41" />
                  </svg>
                </div>)}
            </div>
          </div>

          <div className="h-px bg-gray-300 my-8" data-id="element-42"></div>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-43">
            فريق ديال العلماء المغاربة خدموا سنوات من البحث السري باش يفهموا هاد
            المشكل.
          </p>

          {/* Scientists/Laboratory Image */}
          <div className="mb-8" data-id="element-44">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jL7oE6QZozhnE6x7SuXV2J/shutterstock_1268263801-1.jpg" alt="فريق البحث العلمي المغربي" className="w-full rounded-lg shadow-lg" data-id="element-45" />
          </div>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-46">
            ولقاو حاجة صادمة:
          </p>

          <div className="bg-red-50 border-r-4 border-red-600 p-6 rounded-lg mb-8" data-id="element-47">
            <p className="text-red-900 text-xl font-bold" data-id="element-48">
              المشكل ماشي فراسك. المشكل فجسمك.
            </p>
          </div>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-49">
            جسمك كينتج هرمون خفي كيقتل الرغبة... بلا ما تحس بيه.
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-50">
            وهاد الهرمون كيدير حاجة مرعبة فجسمك...
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-6 font-semibold" data-id="element-51">
            كيطفي "المفتاح" اللي كيشعل الرغبة. نهائياً.
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-8" data-id="element-52">
            حتى لو حاولت بكل الطرق، جسمك كيرفض يتجاوب.
          </p>

          <div className="h-px bg-gray-300 my-8" data-id="element-53"></div>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-54">
            ولكن الفريق المغربي لقا حاجة مذهلة...
          </p>

          <div className="bg-[#f0f7f4] border-r-4 border-[#10b981] p-6 rounded-lg mb-8" data-id="element-55">
            <p className="text-[#047857] text-lg leading-relaxed" data-id="element-56">
              مكونات سرية مدفونة فالتراث ديالنا من آلاف السنين... استعملها
              أجدادنا بالطريقة الحلال.
            </p>
          </div>

          <p className="text-gray-800 text-lg leading-relaxed mb-6" data-id="element-57">
            والمثير أكثر؟ معاهد عالمية سرية أثبتت نجاح هاد الطريقة المغربية
            المخفية.
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-6 font-semibold" data-id="element-58">
            فمدة أقصر مما تتوقع، الرجال كيحسو بتحول جذري...
          </p>

          <p className="text-gray-800 text-lg leading-relaxed mb-12" data-id="element-59">
            والزوجات كيشوفو معجزة.
          </p>
        </div>

        {/* CTA Button - High Converting Blue */}
        <div className="flex justify-center mb-8" data-id="element-60">
          <button onClick={handleCTAClick} className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold text-lg md:text-xl px-8 md:px-12 py-5 md:py-6 rounded-lg shadow-xl transition-all duration-200 transform hover:scale-105 flex items-center gap-3" data-id="element-61">
            احصل على المكونات السرية قبل ما تنفد
            <span className="text-2xl" data-id="element-62">→</span>
          </button>
        </div>

        {/* Urgency Copy Below Button */}
        <div className="text-center mb-12" data-id="element-63">
          <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-3" data-id="element-64">
            <span className="font-bold" data-id="element-65">واش قريتي كلشي اللي فوق؟</span> مزيان.
          </p>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-3" data-id="element-66">
            دابا خاصك تكليكي على الزر الأزرق اللي فوق باش تدخل للصفحة اللي فيها
            التفاصيل كاملة.
          </p>
          <p className="text-gray-800 text-base md:text-lg leading-relaxed font-semibold" data-id="element-67">
            ماتستناش. المخزون كيسالي كل ساعة... وإلا تأخرتي، غادي تندم.
          </p>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-[#2d5f3f] text-white py-8 mt-12" data-id="element-68">
        <div className="max-w-4xl mx-auto px-4" data-id="element-69">
          {/* Footer Links */}
          <div className="flex flex-wrap justify-center gap-4 mb-6 text-sm" data-id="element-70">
            <a href="https://bioseena.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors" data-id="element-71">
              Privacy Policy
            </a>
            <span className="text-gray-400" data-id="element-72">|</span>
            <a href="https://bioseena.com/pages/terms-conditions" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors" data-id="element-73">
              Terms of service
            </a>
            <span className="text-gray-400" data-id="element-74">|</span>
            <a href="https://bioseena.com/pages/mission" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors" data-id="element-75">
              Our Promise
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center text-sm" data-id="element-76">
            <p data-id="element-77">© 2025 Bioseena. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
}